import { ITerms } from '../../types/interfaces';

// другая  запись будет на валидна
// tslint:disable-next-line:no-object-literal-type-assertion
export function hasTerms<T>(obj: ITerms<T> = {} as ITerms<T>, val: T[]): boolean {
  return (obj.value || []).some((v) => val.includes(v));
}
